/* eslint-disable @typescript-eslint/explicit-function-return-type */
type Div = JSX.IntrinsicElements['div'];

export type BaseBoxProps = Div & {
  direction?: Div['dir'];
  ariaLabel?: Div['aria-label'];
  ariaSelected?: Div['aria-selected'];
  ariaLabelledBy?: Div['aria-labelledby'];
  ariaDescribedBy?: Div['aria-describedby'];
  ariaOrientation?: Div['aria-orientation'];
  ariaDisabled?: Div['aria-disabled'];
  ariaControls?: Div['aria-controls'];
  ariaHidden?: Div['aria-hidden'];
  ariaLive?: Div['aria-live'];
  ariaLevel?: Div['aria-level'];
  ariaHasPopUp?: Div['aria-haspopup'];
  focusReferences?: Div['ref'];
  dataHeight?: string;
  dataTestId?: string;
  dataItemSelected?: string;
  dataItemHighlighted?: string;
  dataSrc?: string;
  dataDefaultImage?: string;
  dataOverlayGradient?: string;
  ariaRoleDescription?: string;
  ariaCurrent?: Div['aria-current'];
  ariaModal?: Div['aria-modal'];
  dataToolTipId?: string;
};

export function mapBoxProps(props: BaseBoxProps) {
  const {
    children,
    onClick,
    onClickCapture,
    onMouseEnter,
    onMouseLeave,
    onMouseDown,
    onMouseMove,
    id,
    onFocus,
    onBlur,
    onKeyDown,
    onScroll,
    direction,
    title,
    tabIndex,
    role,
    ariaLabel,
    ariaLevel,
    ariaSelected,
    ariaLabelledBy,
    ariaDescribedBy,
    ariaDisabled,
    ariaOrientation,
    ariaControls,
    ariaHidden,
    ariaLive,
    ariaHasPopUp,
    focusReferences,
    dataOverlayGradient,
    dataHeight,
    dataTestId,
    dataItemSelected,
    dataItemHighlighted,
    dataSrc,
    dataDefaultImage,
    ariaRoleDescription,
    ariaCurrent,
    ariaModal,
    dataToolTipId
  } = props;

  return {
    role,
    id,
    dir: direction,
    title,
    tabIndex,
    ref: focusReferences,
    onClick,
    onMouseEnter,
    onMouseLeave,
    onMouseDown,
    onMouseMove,
    onBlur,
    onFocus,
    onScroll,
    onKeyDown,
    onClickCapture,
    'aria-label': ariaLabel,
    'aria-level': ariaLevel,
    'aria-selected': ariaSelected,
    'aria-labelledby': ariaLabelledBy,
    'aria-describedby': ariaDescribedBy,
    'aria-hidden': ariaHidden,
    'aria-live': ariaLive,
    'data-overlay-gradient': dataOverlayGradient,
    'data-height': dataHeight,
    'data-item-selected': dataItemSelected,
    'data-item-highlighted': dataItemHighlighted,
    'data-testid': dataTestId,
    'data-src': dataSrc,
    'data-default-image': dataDefaultImage,
    'aria-haspopup': ariaHasPopUp,
    'aria-roledescription': ariaRoleDescription,
    'aria-current': ariaCurrent,
    'aria-orientation': ariaOrientation,
    'aria-controls': ariaControls,
    'aria-disabled': ariaDisabled,
    'aria-modal': ariaModal,
    'data-tooltip-id': dataToolTipId,
    children
  };
}
